import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=52096805&scoped=true"
var script = {}
import style0 from "./Support.vue?vue&type=style&index=0&id=52096805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52096805",
  null
  
)

export default component.exports